<div class="recetario-banner" *ngIf="recetarioStatus && (estado === 'no_habilitado' || estado === 'faltan_datos')">

  <!-- No habilitado -->
  <div *ngIf="estado === 'no_habilitado'" class="banner-content">
    <mat-icon class="banner-icon">report_problem</mat-icon>
    <div class="banner-text">
      <strong>Recetas Digitales -</strong>
      <span>Tu plan actual no incluye esta funcionalidad. Consulta con tu administrador para habilitarla.</span>
    </div>
  </div>

  <!-- Habilitado pero faltan datos -->
  <div *ngIf="estado === 'faltan_datos'" class="banner-content">
    <mat-icon class="banner-icon">report_problem</mat-icon>
    <div class="banner-text">
      <strong>Recetas Digitales -</strong>
      <span>Para emitir recetas digitales, completa los siguientes datos:
        <strong *ngFor="let campo of recetarioStatus.datosFaltantes; let last = last">{{ getLabel(campo) }}<span *ngIf="!last">, </span></strong>
      </span>
    </div>
  </div>

</div>
